/**
 * Helpers compartidos de las pantallas de OTP por correo (login MFA).
 * Funciones puras — fuente única de `maskEmail` / `formatTime`.
 */

/**
 * Backend OTP TTL — 2 minutos (OTP_EXPIRATION_TIME=120 en messages-business).
 * El user puede pedir un OTP nuevo solo después de que expire el actual.
 */
export const OTP_RESEND_COUNTDOWN_SECONDS = 120;

/** Longitud del OTP por correo (messages-business EMAIL): 4 dígitos. */
export const EMAIL_OTP_LENGTH = 4;

/** Longitud del OTP por app autenticadora (TOTP / SOFTWARE_TOKEN_MFA): 6 dígitos. */
export const TOTP_LENGTH = 6;

/**
 * Enmascara el email: `arg@somosfiado.com` → `a**@somosfiado.com`.
 * Para mostrar dónde se envió el OTP sin filtrar el email completo en la UI.
 */
export function maskEmail(email: string): string {
  const [local, domain] = email.split("@");
  if (!local || !domain) return email;
  const visible = local.slice(0, 1);
  return `${visible}${"*".repeat(Math.max(2, local.length - 1))}@${domain}`;
}

/**
 * Enmascara un teléfono dejando visibles solo los últimos 2 dígitos: `+5215551234` → `+••••••••34`.
 * Para mostrar a dónde se envió el OTP sin filtrar el número completo (anti-PII). Preserva un `+`
 * inicial. Números de ≤2 dígitos se devuelven tal cual.
 */
export function maskPhone(phone: string): string {
  const trimmed = phone.trim();
  const plus = trimmed.startsWith("+") ? "+" : "";
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length <= 2) return trimmed;
  const last2 = digits.slice(-2);
  return `${plus}${"•".repeat(digits.length - 2)}${last2}`;
}

/** Segundos → `m:ss` (ej. 120 → `2:00`, 9 → `0:09`). */
export function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString()}:${s.toString().padStart(2, "0")}`;
}
